import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import muiThemeable from 'material-ui/styles/muiThemeable';


import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import {Container, Row, Col} from './BootstrapGrid';
import {Display1, Title} from './Typography';
import GetInTouchSection from './GetInTouchSection';

import firebase from './firebase';

var SubHeader = muiThemeable()(function(props) {
  return (
    <div style={{
             height: "2em",
             backgroundColor: props.muiTheme.palette.primary1Color
           }}></div>
         )
});

class AccountSection extends Component {
  render() {
    return (
      <div>
        <Container style={{
              maxWidth: '90%',
              width: '600px',
              margin: 'auto',
            }}>
          <Row>
            <Col cols={12}>
              <Display1 style={{marginTop: '1em', marginBottom: '0.2em'}}>
                {this.props.title}
              </Display1>
            </Col>
          </Row>
          {this.props.children}
        </Container>
      </div>
    )
  }
}

class AccountRow extends Component {
  render() {
    return (
      <Row style={{marginBottom: "10px"}}>
        <Col cols={6}>
          <Title style={{fontWeight: 'bold'}}>{this.props.title}</Title>
        </Col>
        <Col cols={6}>
          <Title>{this.props.value}</Title>
        </Col>
      </Row>
    )
  }
}

class AccountPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      userData: null,
      subscription: null,
      subscriptionCancelDialogOpen: false,
    }
  }

  updateUserData(dataSnapshot) {
    console.log(dataSnapshot.val());
    this.setState({userData: dataSnapshot.val()});

    if (dataSnapshot.child('subscription/subscription/id').exists()) {
      var subscription_id = dataSnapshot.child('subscription/subscription/id').val();
      var user_id = firebase.auth().currentUser.uid;

      firebase.auth().currentUser.getToken(/* forceRefresh */ false).then((id_token) => {
        fetch(`/api/subscription_information?subscription_id=${subscription_id}&id_token=${id_token}&user_id=${user_id}`).then(
          (response) =>
          response.json().then((json) => this.setState({subscription: json }))
        );
      }).catch((error) => console.log(error));
    }


  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        this.setState({user:user});
        if (this.userRef != null) {
          this.userRef.off();
        }
        this.userRef = firebase.database().ref('users').child(user.uid);
        this.userRef.on('value', (dataSnapshot) => this.updateUserData(dataSnapshot));

      } else {
        document.location="/login";
      }
    }.bind(this));


  }


  handleOpen = () => {
    this.setState({subscriptionCancelDialogOpen: true});
  };

  handleClose = () => {
    this.setState({subscriptionCancelDialogOpen: false});
  };

  handleCancelSubscription = () => {
    this.handleClose();
    this.userRef.child('cancellation_pending').set(true);

  };

  subscriptionState = () => {
    if (this.state.userData.cancellation_pending === true) {
      return "Cancellation in progress";
    } else {
      return this.state.subscription.subscription.status;
    }
  }

  render() {
    const subscriptionCancelDialogActions = [
      <RaisedButton
        label="Keep Subscription"
        primary={true}
        onTouchTap={this.handleClose}
      />,
    <RaisedButton
        label="Cancel Subscription"
        primary={false}
        onTouchTap={this.handleCancelSubscription}
      />,
    ];

    return (
      <div>
         <HomeGalleryHeader />
         <SubHeader></SubHeader>

       {this.state.user && this.state.userData && this.state.subscription &&
         <div style={{
             marginBottom: "20px",
           }}>
           <AccountSection title="Your Account">
             <AccountRow title="Name" value={this.state.userData.displayName} />
             <AccountRow title="Email" value={this.state.userData.email} />
           </AccountSection>
           <AccountSection title="Plan Info">
             <AccountRow title="Subscription" value={this.subscriptionState()} />
             <AccountRow title="Plan" value="Discovery" />
             <AccountRow title="Next Billing Day" value={this.state.subscription.subscription.next_billing_date} />
             <AccountRow title="Next Billing Amount" value={"$" + this.state.subscription.subscription.price} />
             <AccountRow title={<a onClick={this.handleOpen}>Cancel subscription</a>}></AccountRow>
           </AccountSection>
           { this.state.userData.shipping &&
             <AccountSection title="Delivery Info">
               <AccountRow title="Name" value={this.state.userData.shipping.name} />
               <AccountRow title="Address" value={this.state.userData.shipping.address} />
               <AccountRow title="Phone" value={this.state.userData.shipping.phone} />
             </AccountSection>
           }
           <AccountSection title="Payments">
             { this.state.subscription.payment_method.cardholder_name &&
               <AccountRow title="Name on Card" value={this.state.subscription.payment_method.cardholder_name} />
              }
             <AccountRow title="Card Type" value={this.state.subscription.payment_method.card_type} />
             <AccountRow title="Card Number" value={`Ending in ${this.state.subscription.payment_method.last_4}`} />
             <AccountRow title="Expiration" value={this.state.subscription.payment_method.expiration_date} />
           </AccountSection>
         </div>
       }

       <GetInTouchSection />

       <Dialog
         actions={subscriptionCancelDialogActions}
         modal={false}
         open={this.state.subscriptionCancelDialogOpen}
         onRequestClose={this.handleClose}
       >
         {"Are you sure that you want to cancel your subscription? To cancel, you need to either return or purchase the art you currently have. We'll contact you by email to arrange for a pickup."}
       </Dialog>

         <HomeGalleryFooter />
      </div>
    );
  }
}

export default AccountPage;



// WEBPACK FOOTER //
// ./src/AccountPage.js